import { NotificationList } from 'components/NotificationList';
import { NotificationHome } from '../features/notification/noticationHome/ui/NotificationHome';

export const NotificationListPage = (): JSX.Element => {
    return (
        <>
            <NotificationHome />
        </>
    );
}